import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { FadeUp } from './ui/FadeUp';
export function ProblemSection() {
  const painPoints = ['Policies scattered across documents', 'Compliance questions popping up weekly', 'Managers unsure how to handle employee issues', 'Hiring and onboarding happening without structure'];
  return <section className="py-28 bg-section-lavender" data-id="element-321">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-322">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-323">
          <FadeUp data-id="element-324">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-325">
              Most companies wait too long to fix HR.
            </h2>
            <div className="pl-6 border-l-2 border-purple-300" data-id="element-326">
              <p className="text-lg text-gray-700 mb-6" data-id="element-327">
                Startups and growing companies eventually reach a point where HR
                becomes messy.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-328">
                {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-329">
                    <AlertCircleIcon className="w-5 h-5 text-purple-400 shrink-0 mt-0.5" data-id="element-330" />
                    <span className="text-gray-600" data-id="element-331">{point}</span>
                  </li>)}
              </ul>
              <div className="bg-white p-6 rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-332">
                <p className="text-gray-600 mb-2" data-id="element-333">
                  Hiring a full HR team is expensive.
                </p>
                <p className="text-gray-600 mb-4" data-id="element-334">
                  Doing nothing creates risk.
                </p>
                <p className="text-lg font-bold text-gray-900" data-id="element-335">
                  SparkHR sits in the middle.
                </p>
              </div>
            </div>
          </FadeUp>

          <FadeUp delay={0.2} className="hidden md:flex justify-center relative" data-id="element-336">
            {/* Decorative abstract representation of "messy" to "organized" */}
            <div className="relative w-full max-w-sm aspect-square" data-id="element-337">
              {/* Messy side */}
              <div className="absolute top-10 left-0 w-32 h-32 bg-gray-100 rounded-lg rotate-12 opacity-50 blur-[2px]" data-id="element-338"></div>
              <div className="absolute top-32 left-10 w-24 h-24 bg-purple-100 rounded-full -rotate-12 opacity-40 blur-[1px]" data-id="element-339"></div>
              <div className="absolute bottom-20 left-4 w-40 h-16 bg-gray-100 rounded-xl rotate-6 opacity-60" data-id="element-340"></div>

              {/* Arrow */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-sm border border-[#eee]" data-id="element-341">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-300" data-id="element-342">
                  <path d="M5 12h14M12 5l7 7-7 7" data-id="element-343" />
                </svg>
              </div>

              {/* Organized side */}
              <div className="absolute top-12 right-0 w-40 h-12 bg-white border border-[#eee] rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-344"></div>
              <div className="absolute top-28 right-0 w-40 h-12 bg-white border border-[#eee] rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-345"></div>
              <div className="absolute top-44 right-0 w-40 h-12 bg-white border border-[#eee] rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-346"></div>
              <div className="absolute top-60 right-0 w-40 h-12 bg-white border border-[#eee] rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-347"></div>

              {/* Overlay gradient to tie it together */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/10 pointer-events-none" data-id="element-348"></div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>;
}